import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const writingsColumns: ColumnFormatted[] = [
  {
    type: "string",
    key: "ecritsDescriptionNumeroEnregistrement",
    visible: true,
  },
  { type: "image", key: "vignette", visible: true },
  { type: "string", key: "ecritsDescriptionTitre", visible: true },
  { type: "string", key: "ecritsDescriptionType", visible: true },
  { type: "string", key: "ecritsDescriptionClassement", visible: true },
  { type: "string", key: "ecritsDescriptionRangement" },
  { type: "string", key: "ecritsDescriptionLocalisation", visible: true },
  { type: "string", key: "ecritsDescriptionNombreExemplairesArchives" },
  { type: "string", key: "ecritsDescriptionTheme" },
  { type: "string", key: "ecritsDescriptionDate", visible: true },
  { type: "string", key: "ecritsDescriptionTechnique" },
  { type: "string", key: "ecritsDescriptionLieuDeCreation" },
  { type: "string", key: "ecritsDescriptionPhotographe" },
  { type: "string", key: "ecritsDescriptionCopyright" },
  { type: "boolean", key: "ecritsDescriptionCopies" },
  { type: "string", key: "ecritsDescriptionNombreFeuillet" },
  { type: "richtext", key: "ecritsDescriptionLegendeRedigee" },
  { type: "string", key: "ecritsDescriptionNotes" },
  { type: "string", key: "ecritsDescriptionRetranscription" },
  { type: "boolean", key: "ecritsFichierPhotoBasseDefinitionUniquement" },
  { type: "boolean", key: "ecritsFichierPhotoScanAFaire" },
  { type: "boolean", key: "ecritsFichierPhotoOkWeb" },
  { type: "boolean", key: "ecritsFichierPhotoHdOk" },
  { type: "boolean", key: "ecritsValidationPublicationNumerisee" },
  { type: "boolean", key: "ecritsValidationPdfEtOcrOk" },
  { type: "boolean", key: "ecritsAcquisitionDocumentAAcquerir" },
  { type: "boolean", key: "ecritsAcquisitionDocumentAcquis" },
  { type: "string", key: "ecritsAcquisitionDateAcquisition" },
  { type: "string", key: "ecritsAcquisitionVendeur" },
  { type: "string", key: "ecritsAcquisitionNotes" },
  { type: "string", key: "ecritsMouvementsDepot" },
  { type: "richtext", key: "ecritsMouvementsNotesDepot" },
  { type: "string", key: "ecritsMouvementsValeurAssurance" },
  { type: "status", key: "ecritsPublicationStatus", visible: true },
  { type: "string", key: "sources" },
];

export const writingsAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "ecritsDescription",
    fields: [
      { type: "string", key: "ecritsDescriptionNumeroEnregistrement" },
      { type: "boolean", key: "ecritsDescriptionCopies" },
      { type: "string", key: "ecritsDescriptionType" },
      { type: "string", key: "ecritsDescriptionClassement" },
      { type: "string", key: "ecritsDescriptionRangement" },
      { type: "string", key: "ecritsDescriptionLocalisation" },
      { type: "string", key: "ecritsDescriptionNombreExemplairesArchives" },
      { type: "string", key: "ecritsDescriptionTitre" },
      { type: "string", key: "ecritsDescriptionDate" },
      { type: "string", key: "ecritsDescriptionTheme" },
      { type: "string", key: "ecritsDescriptionDimensions" },
      { type: "string", key: "ecritsDescriptionTechnique" },
      { type: "string", key: "ecritsDescriptionLieuDeCreation" },
      { type: "string", key: "ecritsDescriptionPhotographe" },
      { type: "string", key: "ecritsDescriptionCopyright" },
      { type: "string", key: "ecritsDescriptionNombreFeuillet" },
      { type: "string", key: "ecritsDescriptionLegendeRedigee" },
      { type: "string", key: "ecritsDescriptionNotes" },
      { type: "boolean", key: "ecritsFichierPhotoBasseDefinitionUniquement" },
      { type: "boolean", key: "ecritsFichierPhotoScanAFaire" },
      { type: "boolean", key: "ecritsFichierPhotoOkWeb" },
      { type: "boolean", key: "ecritsFichierPhotoHdOk" },
      { type: "boolean", key: "ecritsValidationPublicationNumerisee" },
      { type: "boolean", key: "ecritsValidationPdfEtOcrOk" },
      { type: "boolean", key: "ecritsAcquisitionDocumentAAcquerir" },
      { type: "boolean", key: "ecritsAcquisitionDocumentAcquis" },
      { type: "string", key: "ecritsAcquisitionDateAcquisition" },
      { type: "string", key: "ecritsAcquisitionVendeur" },
      { type: "string", key: "ecritsAcquisitionNotes" },
      { type: "string", key: "ecritsMouvementsDepot" },
      { type: "string", key: "ecritsMouvementsNotesDepot" },
      { type: "string", key: "ecritsMouvementsValeurAssurance" },
    ],
  },
  {
    type: "group",
    label: "retranscription",
    fields: [{ type: "string", key: "ecritsDescriptionRetranscription" }],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
